// extracted by mini-css-extract-plugin
export var alignCenter = "_6k-d";
export var bannerShown = "_6k-6";
export var buttonContent = "_6k-0";
export var cardList = "_6k-1";
export var centerContent = "_6k-2";
export var chevron = "_6k-3";
export var closePanelButton = "_6k-k";
export var conversationContextContainer = "_6k-l";
export var conversationDetailContainer = "_6k-4";
export var detailWrapper = "_6k-7";
export var dropdownButton = "_6k-e";
export var dropdownTitle = "_6k-9";
export var fullHeight = "_6k-5";
export var hidden = "_6k-a";
export var icon = "_6k-b";
export var mergeSuggestionWrapper = "_6k-m";
export var panel = "_6k-i";
export var portalButtonsWrapper = "_6k-c";
export var right = "_6k-j";
export var tableSummaryContainer = "_6k-8";
export var tableSummaryHeader = "_6k-g";
export var threeDotsButton = "_6k-f";
export var wide = "_6k-h";